import { MortgageRatesCompany } from "./MortgageRatesCompany";
import { ThemeContext } from "./ThemeContext";

export const AnnuitiesCompany = (props) => (
	<ThemeContext.Provider value={{ visitLinkText: "Check My Rate" }}>
		<MortgageRatesCompany {...props} />
	</ThemeContext.Provider>
);
